// Hover-video previews are desktop-only - below 1240px the video source is
// never even set on the <video> element, so nothing downloads there; only
// the static product image shows.
document.addEventListener('mouseenter', function (event) {
  if (window.innerWidth <= 1240) return;

  const card = event.target.closest && event.target.closest('.card-wrapper');
  if (!card) return;

  const video = card.querySelector('.card__hover-video');
  if (!video) return;

  if (!video.getAttribute('src')) {
    const source = video.dataset.videoSrc;
    if (!source) return;
    video.setAttribute('src', source);
  }

  video.play().catch(() => {});
}, true);

document.addEventListener('mouseleave', function (event) {
  const card = event.target.closest && event.target.closest('.card-wrapper');
  if (!card) return;

  const video = card.querySelector('.card__hover-video');
  if (!video) return;

  video.pause();
}, true);
